/* Landing Upstart drive-to-store — UI de page : reveal au scroll + barre CTA collante mobile.
   Extrait du monolithe (factorisation ADR-007). Le sélecteur racine, autrefois
   basé sur l'id de section injecté en Liquid, cible désormais .uds[data-section-id]
   car un asset statique n'est pas interprété par Liquid. Comportement inchangé. */
(function() {
  var root = document.querySelector('.uds[data-section-id]');
  if (!root) return;

  document.body.classList.add('uds-page-active');
  var hostSection = root.closest('.shopify-section');
  if (hostSection) hostSection.classList.add('uds-section-fullbleed');

  var revealItems = root.querySelectorAll('[data-reveal]');
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduceMotion) {
    revealItems.forEach(function(item) { item.classList.add('is-visible'); });
  } else if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    revealItems.forEach(function(item) { revealObserver.observe(item); });
  } else {
    revealItems.forEach(function(item) { item.classList.add('is-visible'); });
  }

  var mobileSticky = root.querySelector('[data-uds-mobile-sticky]');
  var updateMobileSticky = function() {
    if (!mobileSticky) return;
    mobileSticky.classList.toggle('is-visible', window.scrollY > window.innerHeight * 0.9);
  };

  updateMobileSticky();
  window.addEventListener('scroll', updateMobileSticky, { passive: true });
  window.addEventListener('resize', updateMobileSticky);
})();
